/**
 * Professions Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import {store} from "../../store";
import AppConfig from "../../../constants/AppConfig";

// States
const state = {
    adviceResponse: {},
};

// Getters
const getters = {
    adviceResponse: state => {
        return state.adviceResponse
    },
};

// Actions
const actions = {
    getAdviceResponse(context, payload) {
        function successCallback(response) {
            context.commit('getAdviceResponseHandler', { adviceResponse: response.data.avis });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        /*const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.AdviceResponse.Get, localToken, successCallback, errorCallback, payload.errorMessages);
*/
        const localToken = localStorage.getItem('ms-token');

        const url = AppConfig.apiUrl + apiModel.AdviceResponse.Get.url + '/' + payload.args.adviceSlug;

        Vue.axios.get(
            url,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    // 'Content-Type': 'multipart/form-data'
                }
            }
        )
        .then(successCallback)
        .catch(errorCallback);
    },
};

// Mutations
const mutations = {
    getAdviceResponseHandler(state, { adviceResponse }) {
        // Update followed state
        state.adviceResponse = adviceResponse;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}
